module.exports = __webpack_public_path__ + "static/contact-image-d857314f5deac05851a9de9714940dcb.jpg";